import React from 'react';
import StaffGridActions from './StaffGridActions';
import {Tooltip} from 'material-ui';

const staffGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        id: 'is_active',
        Header: 'Enabled',
        accessor: 'is_active',
        show: false,
    },
    {
        Header: 'Title',
        accessor: 'title_name',
        width: 60,
        sortable: false,
        Cell: (props) => {
            return <span>{props.value}</span>;
        },
    },
    {
        Header: 'Full Name',
        accessor: 'firstname',
        width: 250,
        Cell: (props) => {
            const fullName =
                props.original.firstname + ' ' + props.original.name;
            return <span>{fullName.length > 1 ? fullName : '-'}</span>;
        },
    },
    {
        Header: 'Jobs',
        accessor: 'jobs',
        sortable: false,
        Cell: (props) => {
            const jobsItems = props.value
                .map((item) => item.display_name)
                .join(', ');
            return (
                <Tooltip title={jobsItems}>
                    <span>{jobsItems.length > 1 ? jobsItems : '-'}</span>
                </Tooltip>
            );
        },
    },
    {
        Header: 'Teams',
        accessor: 'teams',
        sortable: false,
        Cell: (props) => {
            const teamsItems = props.value
                .map((item) => item.display_name)
                .join(', ');
            return (
                <Tooltip title={teamsItems}>
                    <span>{teamsItems.length > 1 ? teamsItems : '-'}</span>
                </Tooltip>
            );
        },
    },
    {
        Header: 'Destinations',
        accessor: 'products',
        sortable: false,
        Cell: (props) => {
            const destinationsItems = props.value
                .map((item) => item.destination_name)
                .join(', ');
            return (
                <Tooltip title={destinationsItems}>
                    <span>
                        {destinationsItems.length > 1 ? destinationsItems : '-'}
                    </span>
                </Tooltip>
            );
        },
    },
    {
        Header: 'Offices',
        accessor: 'sites',
        width: 400,
        sortable: false,
        Cell: (props) => {
            const sitesItems = props.value
                .map((item) => item.display_name)
                .join(', ');
            return (
                <Tooltip title={sitesItems} style={{maxWidth: 400}}>
                    <span>{sitesItems.length > 1 ? sitesItems : '-'}</span>
                </Tooltip>
            );
        },
    },
    {
        Header: 'Actions',
        width: 150,
        sortable: false,
        Cell: (props) => <StaffGridActions props={props} />,
    },
];

export default staffGridColumns;



// WEBPACK FOOTER //
// ./src/containers/staff/StaffGridColumns.jsx